/* AUTO-GENERATED from @pomelo/tokens. Do not edit — run `pnpm sync:theme`. */

// packages/tokens/src/themes/default.ts
var defaultTheme = {
  // ── Colors ──────────────────────────────────────────────
  colors: {
    // Brand — Bank Rakyat Blue (#00539B)
    primary: {
      50: "#EAF2F9",
      100: "#CFE0F0",
      200: "#9FC1E1",
      300: "#6FA2D2",
      400: "#3F83C3",
      500: "#00539B",
      600: "#00457F",
      700: "#003563",
      800: "#002647",
      900: "#00172B",
      950: "#000B16"
    },
    secondary: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    // Neutrals
    neutral: {
      0: "#ffffff",
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    // Semantic / Status
    success: {
      light: "#dcfce7",
      DEFAULT: "#22c55e",
      dark: "#15803d"
    },
    warning: {
      light: "#fef9c3",
      DEFAULT: "#eab308",
      dark: "#a16207"
    },
    error: {
      light: "#fee2e2",
      DEFAULT: "#ef4444",
      dark: "#b91c1c"
    },
    info: {
      light: "#dbeafe",
      DEFAULT: "#3b82f6",
      dark: "#1d4ed8"
    },
    // Surface & Background
    background: {
      page: "#F7F8FA",
      card: "#ffffff",
      sidebar: "#0F1B2D",
      overlay: "rgba(0, 0, 0, 0.5)",
      hero: "#111827"
    },
    // Sidebar
    sidebar: {
      bg: "#000000",
      border: "rgba(255, 255, 255, 0.15)",
      text: {
        active: "#ffffff",
        default: "#eef5fc",
        hover: "#ffffff",
        subDefault: "rgba(255, 255, 255, 0.78)",
        sectionHeader: "rgba(255, 255, 255, 0.65)"
      },
      hoverBg: "rgba(255, 255, 255, 0.12)",
      chevron: "rgba(255, 255, 255, 0.7)"
    },
    // Header
    header: {
      bg: "#ffffff",
      border: "#e5e7eb",
      iconDefault: "#6b7280",
      iconMuted: "#9ca3af",
      iconHover: "#4b5563",
      createButton: "#2563eb",
      createButtonHover: "#1d4ed8",
      notificationDot: "#2563eb"
    },
    // Assistant Panel
    assistant: {
      optionBorderHover: "#00539B",
      optionBgHover: "#EAF2F9",
      inputFocusRing: "#00539B"
    },
    // Text
    text: {
      primary: "#111827",
      secondary: "#4b5563",
      tertiary: "#9ca3af",
      inverse: "#ffffff",
      link: "#00457F",
      linkHover: "#003563"
    },
    // Borders
    border: {
      light: "#e5e7eb",
      DEFAULT: "#d1d5db",
      dark: "#9ca3af",
      focus: "#00457F"
    }
  },
  // ── Brand Shorthand ─────────────────────────────────────
  brand: {
    primary: "#00539B",
    primaryHover: "#00457F",
    primaryLight: "#00539B1A",
    primarySubtle: "#00539B08",
    primaryRing: "#00539B33",
    primaryRingActive: "#00539B4D"
  },
  // ── Typography ──────────────────────────────────────────
  typography: {
    fontFamily: {
      heading: ["Inter", "system-ui", "sans-serif"],
      body: ["Inter", "system-ui", "sans-serif"],
      mono: ["JetBrains Mono", "Fira Code", "monospace"]
    },
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      base: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem"
    },
    fontWeight: {
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700"
    },
    lineHeight: {
      tight: "1.25",
      normal: "1.5",
      relaxed: "1.75"
    }
  },
  // ── Spacing ─────────────────────────────────────────────
  spacing: {
    px: "1px",
    0: "0",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    8: "2rem",
    10: "2.5rem",
    12: "3rem",
    16: "4rem",
    20: "5rem",
    24: "6rem"
  },
  // ── Border Radius ───────────────────────────────────────
  borderRadius: {
    none: "0",
    sm: "0.25rem",
    DEFAULT: "0.375rem",
    md: "0.5rem",
    lg: "0.75rem",
    xl: "1rem",
    "2xl": "1.5rem",
    full: "9999px"
  },
  // ── Shadows ─────────────────────────────────────────────
  shadows: {
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    DEFAULT: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
    none: "none"
  },
  // ── Transitions ─────────────────────────────────────────
  transitions: {
    fast: "150ms ease",
    DEFAULT: "200ms ease",
    slow: "300ms ease",
    spring: "500ms cubic-bezier(0.34, 1.56, 0.64, 1)"
  },
  // ── Z-Index ─────────────────────────────────────────────
  zIndex: {
    dropdown: 10,
    sticky: 20,
    overlay: 30,
    modal: 40,
    popover: 50,
    toast: 60,
    tooltip: 70
  },
  // ── Breakpoints ─────────────────────────────────────────
  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
  },
  // ── Layout ──────────────────────────────────────────────
  layout: {
    sidebar: {
      width: "15rem",
      collapsedWidth: "64px"
    },
    header: {
      height: "3.5rem"
    },
    content: {
      maxWidth: "1280px",
      padding: "1.5rem"
    },
    auth: {
      maxWidth: "28rem",
      imagePanelWidth: "50%"
    }
  }
};

// packages/tokens/src/themes/dark.ts
var darkTheme = {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    background: {
      page: "#0A1525",
      card: "#13203A",
      sidebar: "#060D1A",
      overlay: "rgba(0, 0, 0, 0.7)",
      hero: "#0F1B2D"
    },
    text: {
      primary: "#F9FAFB",
      secondary: "#D1D5DB",
      tertiary: "#9CA3AF",
      inverse: "#111827",
      link: "#3F83C3",
      linkHover: "#6FA2D2"
    },
    border: {
      light: "#1F2937",
      DEFAULT: "#374151",
      dark: "#4B5563",
      focus: "#00539B"
    },
    sidebar: {
      ...defaultTheme.colors.sidebar,
      bg: "#060D1A",
      border: "#13203A"
    },
    header: {
      ...defaultTheme.colors.header,
      bg: "#0A1525",
      border: "#1F2937"
    }
  }
};

// packages/tokens/src/themes/pomelo.ts — legacy green theme
var pomeloTheme = {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    primary: {
      50: "#f0fdf6",
      100: "#dcfce9",
      200: "#bbf7d4",
      300: "#7ae8b4",
      400: "#3ddb9c",
      500: "#16CD88",
      600: "#0fa86e",
      700: "#0d8a5a",
      800: "#0a6d47",
      900: "#075a3b",
      950: "#033322"
    },
    sidebar: {
      ...defaultTheme.colors.sidebar,
      text: {
        ...defaultTheme.colors.sidebar.text,
        active: "#16CD88"
      }
    },
    assistant: {
      optionBorderHover: "#16CD88",
      optionBgHover: "#f0fdf6",
      inputFocusRing: "#16CD88"
    },
    text: {
      ...defaultTheme.colors.text,
      link: "#16CD88",
      linkHover: "#0fa86e"
    },
    border: {
      ...defaultTheme.colors.border,
      focus: "#16CD88"
    }
  },
  brand: {
    primary: "#16CD88",
    primaryHover: "#0fa86e",
    primaryLight: "#16CD881A",
    primarySubtle: "#16CD8808",
    primaryRing: "#16CD8833",
    primaryRingActive: "#16CD884D"
  }
};

// packages/tokens/src/themes/index.ts
var themes = {
  default: defaultTheme,
  rabbit: defaultTheme,
  pomelo: pomeloTheme,
  dark: darkTheme
};

// packages/tokens/src/css.ts
function flatten(obj, prefix = "") {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    const k = prefix ? `${prefix}-${key}` : key;
    if (value && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(result, flatten(value, k));
    } else {
      result[k] = Array.isArray(value) ? value.join(", ") : String(value);
    }
  }
  return result;
}
function toCssVars(theme) {
  const flat = flatten(theme);
  return Object.entries(flat).map(([k, v]) => `  --${k.toLowerCase().replace(/_/g, "-")}: ${v};`).join("\n");
}
function generateCss() {
  const blocks = [];
  blocks.push(
    `:root,
[data-theme="default"] {
${toCssVars(themes.default)}
}`
  );
  for (const [name, theme] of Object.entries(themes)) {
    if (name === "default") continue;
    blocks.push(`[data-theme="${name}"] {
${toCssVars(theme)}
}`);
  }
  return blocks.join("\n\n") + "\n";
}

// packages/tokens/src/tenant/defaults.ts
var defaultTenant = {
  brand: {
    name: "Rabbit"
  },
  locale: {
    default: "en-US",
    supported: ["en-US"],
    timezone: "UTC"
  },
  currency: {
    code: "USD"
  }
};

// packages/tokens/src/tenant/defineTenant.ts
function defineTenant(config) {
  return config;
}

// packages/tokens/src/tenant/load.ts
var activeTenant = defaultTenant;
function deepMerge(base, override) {
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const v = override[key];
    if (v && typeof v === "object" && !Array.isArray(v) && out[key] && typeof out[key] === "object") {
      out[key] = deepMerge(out[key], v);
    } else if (v !== void 0) {
      out[key] = v;
    }
  }
  return out;
}
function setTenant(config) {
  activeTenant = deepMerge(defaultTenant, config);
}
function getTenant() {
  return activeTenant;
}

// packages/tokens/src/format/iso4217.ts
var CURRENCY_OFFSETS = {
  // Zero-decimal currencies
  BIF: 1,
  CLP: 1,
  DJF: 1,
  GNF: 1,
  JPY: 1,
  KMF: 1,
  KRW: 1,
  MGA: 1,
  PYG: 1,
  RWF: 1,
  UGX: 1,
  VND: 1,
  VUV: 1,
  XAF: 1,
  XOF: 1,
  XPF: 1,
  // Three-decimal currencies
  BHD: 1e3,
  IQD: 1e3,
  JOD: 1e3,
  KWD: 1e3,
  LYD: 1e3,
  OMR: 1e3,
  TND: 1e3,
  // Four-decimal (rare)
  CLF: 1e4,
  UYW: 1e4
};
function getCurrencyOffset(code) {
  return CURRENCY_OFFSETS[code.toUpperCase()] ?? 100;
}

// packages/tokens/src/format/currency.ts
function formatCurrencyAmount(amount, options = {}) {
  const tenant = getTenant();
  const currency = options.currency ?? tenant.currency.code;
  const locale = options.locale ?? tenant.locale.default;
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const formatOptions = {
    style: "currency",
    currency
  };
  if (typeof options.fractionDigits === "number") {
    formatOptions.minimumFractionDigits = options.fractionDigits;
    formatOptions.maximumFractionDigits = options.fractionDigits;
  }
  return new Intl.NumberFormat(locale, formatOptions).format(safeAmount);
}
function formatCurrency(minorUnits, options = {}) {
  const tenant = getTenant();
  const currency = options.currency ?? tenant.currency.code;
  const offset = getCurrencyOffset(currency);
  const majorUnits = minorUnits / offset;
  return formatCurrencyAmount(majorUnits, { ...options, currency });
}

export { CURRENCY_OFFSETS, darkTheme, defaultTenant, defaultTheme, defineTenant, formatCurrency, formatCurrencyAmount, generateCss, getCurrencyOffset, getTenant, pomeloTheme, setTenant, defaultTheme as theme, themes, defaultTheme as tokens };